module.exports = __webpack_public_path__ + "static/img/startrip.aaa8078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/startrip.png
// module id = l8yR
// module chunks = 1